import { Popover, PopoverProps } from "antd";
import { ReactNode } from "react";
import styles from "./ActionsPopOver.module.scss";

export interface ActionsPopoverProps extends PopoverProps {
  actions: ReactNode;
}

export default function ActionsPopover({ children, actions, ...props }: ActionsPopoverProps) {
  return (
    <Popover
      placement={"bottomLeft"}
      overlayClassName={styles["actions-overlay"]}
      trigger={["click"]}
      {...props}
      content={<div className={styles.actions}>{actions}</div>}
    >
      {children}
    </Popover>
  );
}
